import React from 'react'
import PropTypes from 'prop-types'
import FullWidthContainer from '../../_common/_containers/FullWidthContainer/FullWidthContainer'
import './style.css'
import ContentContainer from '../../_common/_containers/ContentContainer/index'
import Logo from '../Logo'
import PoweredBy from '../PoweredBy'
import SocialIcon from './SocialIcon'
import _ from 'lodash'


const bynerit = require('./nerit.svg')


const Footer = (props) => {

    const params = props.systemParams
    const logoImgSrc = props.logoImgSrc
    // const company = params.PARAM_ORGANIZATION_COMPANY_NAME
    const phone = getParameterValue( "PARAM_ORGANIZATION_PHONE", params )
    const email = getParameterValue('PARAM_ORGANIZATION_EMAIL', params )
    //const address = params.PARAM_ORGANIZATION_ADDRESS
    const facebook = getParameterValue('PARAM_ORGANIZATION_FACEBOOK', params)
    const twitter = getParameterValue('PARAM_ORGANIZATION_TWITTER' , params )
    const gplus = getParameterValue('PARAM_ORGANIZATION_GOOGLE_PLUS' , params )
    const instagram = getParameterValue('PARAM_ORGANIZATION_INSTAGRAM' , params)

  //  console.log(props)


    return (
        <FullWidthContainer
            style={{
                backgroundImage: `url('${require('./../../../assets/images/minhacentral-logo-background.svg')}')`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover'
            }}
        >

            <ContentContainer center className={'container'}>
                <SocialIcon facebookUrl={facebook} instagramUrl={instagram} googlePlusUrl={gplus} twitterUrl={twitter}/>
                <div className="nrt-logo-nerit">
                    <img src={bynerit} width="50px"/>
                    <span>{new Date().getFullYear()}® - Todos os direitos reservados.</span>
                </div>

                <div className="logo-container">
                    <div className="img-wrapper">
                        <Logo imgSrc={logoImgSrc} style={{maxHeight: '3.5rem'}}/>
                    </div>
                </div>

                <div className="powered">
                    <img src={require('./../../../assets/images/footer-separator.png')}/>
                    <PoweredBy/>
                </div>
                <div className="info">
                    <div className="column">
                        <img src={require('./../../../assets/images/phone.png')} style={{width: 32}}/>
                        <ul>{!!phone && phone.split(';').map((p, i ) => <li key={'phone-' + i }>{p}</li>)}</ul>
                    </div>

                    <div className="column email">
                        <img src={require('./../../../assets/images/email.png')} style={{width: 32}}/>
                        <a href={'mailto:' + email}>{email}</a>
                    </div>
                </div>
            </ContentContainer>
        </FullWidthContainer>
    )

}

const results = {}
function getParameterValue(paramId, params = [] ) {
    if (!!results[paramId])
        return results[paramId]

    const param = params.filter(p=>_.get(p , 'parameterId') === paramId)[0]
    results[paramId] = _.get(param, 'parameterValue' )

    return results[paramId]

}


Footer.propTypes = {
    logoImgSrc: PropTypes.string.isRequired,
    systemParams: PropTypes.object.isRequired
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/_minha-central/Footer/index.js